import * as React from 'react';
import './EFSBuilderTools.scss';
import { Primary } from 'rcd-cpp-ui/ui/button';
import { useActions as useViewActions } from '../../viewActions';
import { useActions as useEFSActions } from '../EFSEditMode/EFSEditModeActions';
import { EFSPersona } from '../efsPersona';
import { useSelector } from '../../../../utils/useSelector';
import { Filters } from '../../../Filters/filters';
import { useSearchParams } from 'react-router-dom';
import URLManager from '../../../../utils/urlManager';
import { excludeEmptyFilters } from '../../../../utils';
import { Resource } from '../../../../enums/Resource';
import AccessControl from '../../../AccessControl/accessControl';

export const EFSBuilderTools = () => {
  const selected = useSelector(s => s.view?.selected);
  const editMode = useSelector(s => s.view?.editMode);
  const hasUnsavedChanges = useSelector(s => s.view?.hasUnsavedChanges);
  const groups = useSelector(s => s.view?.groups);
  const efsItemData = useSelector(s => s.view?.efsItemData);
  const viewRefId = useSelector(s => s.view?.selected?.props?.refId);
  const viewFilters = useSelector(s => s.view?.filters);
  const filters = useSelector(s => s.view?.filters);
  const schemas = useSelector(s => s.planning?.selectedWorkspace?.schemas);
  const newUrlFilters = useSelector(s =>
    URLManager.stringify(excludeEmptyFilters(s.view?.filters))
  );
  const { setEditMode } = useViewActions();
  const { setFilter, setTempFilters } = useViewActions();
  const [searchParams, setSearchParams] = useSearchParams();
  const { loadEFSItemData, emptyEFSItemData } = useEFSActions();
  const curUrlFilters = searchParams.get('f');
  const tempFilters = searchParams.get('tempFilters');
  const vid = searchParams.get('v');
  const setEFSFilter = filter => {
    if (editMode && hasUnsavedChanges) {
      setTempFilters([filter]);
      searchParams.set('tempFilters', new Date().getTime().toString());
      setSearchParams(searchParams);
    } else {
      setFilter(filter);
    }
  };
  React.useEffect(() => {
    if (tempFilters) {
      searchParams.delete('tempFilters');
      setSearchParams(searchParams);
    }
  }, []);
  React.useEffect(() => {
    if (!vid) return;
    if (curUrlFilters != newUrlFilters) {
      if (!newUrlFilters) searchParams.delete('f');
      else searchParams.set('f', newUrlFilters);
    }
    setSearchParams(searchParams);
  }, [newUrlFilters]);

  const requiredFilters = (viewFilters || []).reduce((r, f) => {
    if (f.isRequired) r[f.field] = true;
    return r;
  }, {});
  filters.forEach(f => {
    if (requiredFilters[f.field]) {
      f.isRequired = true;
      requiredFilters[f.field] = false;
    }
  });

  const roleFilter = filters.find(f => f.field === 'Item.role');
  const roleId = roleFilter?.conditions?.[0]?.refIds?.[0];

  React.useEffect(() => {
    emptyEFSItemData();
  }, [roleId]);

  React.useEffect(() => {
    if (efsItemData == null && groups?.length > 0) {
      loadEFSItemData();
    }
  }, [efsItemData, groups]);

  if (!selected) return null;

  return (
    <div className={'efs-builder-tools'}>
      <Filters
        getAPI={null}
        setFilter={setEFSFilter}
        schemas={schemas}
        filters={filters}
        defaultFilters={null}
        viewRefId={viewRefId}
        location="view"
      ></Filters>
      <EFSPersona />
      {!editMode && (
        <AccessControl resource={Resource.efsEdit}>
          <Primary
            className="edit-mode-button view-button"
            buttonSize="small"
            label="Edit Mode"
            onClick={() => setEditMode(true)}
          />
        </AccessControl>
      )}
    </div>
  );
};
